import ChatHomeListItemContent, {
  type ChatHomeListItemProps,
} from '@/components/Chat/ChatHomeListItemContent';

export default function ChatHomeListItem({ fragment }: ChatHomeListItemProps) {
  return <ChatHomeListItemContent fragment={fragment} />;
}
